import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 进度条配置
NProgress.configure({
  // 初始化时的最小百分比
  minimum: 0.3,
  // 递增进度条的速度
  speed: 500,
  // 动画方式
  easing: 'ease',
  // 自动递增间隔
  trickleSpeed: 200,
  // 是否显示加载ico
  showSpinner: false
})

const start = () => {
  NProgress.start()
}

const done = () => {
  NProgress.done()
}

export default {
  start,
  done
}
